import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";

export default function CellCheckbox<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as boolean;

  const [value, setValue] = useState(cellValue);

  useEffect(() => {
    setValue(cellValue);
  }, [cellValue]);

  return (
    <input
      type="checkbox"
      checked={value}
      onChange={() => {
        setValue(!value);
      }}
      onBlur={(event) => {
        const newValue = event.target.checked;
        if (newValue === cellValue) return;
        try {
          updateData?.(row, columnId, newValue);
        } catch (error) {
          console.error(error);
          setValue(cellValue);
        }
      }}
      disabled={isUpdating}
      className="form-checkbox h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded disabled:opacity-50"
    />
  );
}
